module.exports = __webpack_public_path__ + "img/googleAdsWeavr.94532e8a.svg";